@if (field.inputType=='Float') {
  <mat-form-field class="dynamicForm_alignment" [formGroup]="group">
    @if (field.description) {
      <p [innerHTML]="field.description"></p>
    }
    <mat-label>{{field.labelName}}</mat-label>
    <input matInput onkeypress="return event.charCode != 45" [formControlName]="field.labelCode" type="number" step="0.01" #number
      (input)="(isMaxNumberCodes && addmaxNumber(number.value)) || (isRestrictDecimal && validateDecimal(number.value))"
      (blur)="addZeroes(number.value)" autocomplete="off" [required]="isRequired">
      <mat-hint align="start">{{field.comment}}</mat-hint>
      @for (validation of field.validations; track validation) {
        <ng-container ngProjectAs="mat-error">
          @if (group.get(field.labelCode).hasError('min') && validation.name.toLocaleLowerCase() =='rangevalidator') {
            <mat-error>{{validation.message}}</mat-error>
          }
          @if (group.get(field.labelCode).hasError('max') && validation.name.toLocaleLowerCase() =='rangevalidator') {
            <mat-error>{{validation.message}}</mat-error>
          }
          @if (group.get(field.labelCode).hasError(validation.name.toLocaleLowerCase()) && validation.name.toLocaleLowerCase() != 'rangevalidator' && validation.name.toLocaleLowerCase()!==required) {
            <mat-error>{{validation.message}}</mat-error>
          }
          @if (group.get(field.labelCode).hasError(required) && validation.name.toLocaleLowerCase()===required ) {
            <mat-error class="error_font">{{field.labelName}} is mandatory</mat-error>
          }
        </ng-container>
      }
    </mat-form-field>
  }

  @if (field.inputType=='Integer') {
    <mat-form-field class="dynamicForm_alignment" [formGroup]="group">
      @if (field.description) {
        <p [innerHTML]="field.description"></p>
      }
      <mat-label>{{field.labelName}}</mat-label>
      <input matInput onkeypress="return event.charCode != 45" [formControlName]="field.labelCode"  type="number" #number
        (input)="(isMaxNumberCodes && addmaxNumber(number.value))"
        autocomplete="off" [required]="isRequired">
        <mat-hint align="start">{{field.comment}}</mat-hint>
        @for (validation of field.validations; track validation) {
          <ng-container ngProjectAs="mat-error">
            @if (group.get(field.labelCode).hasError('min') && validation.name.toLocaleLowerCase() =='rangevalidator') {
              <mat-error>{{validation.message}}</mat-error>
            }
            @if (group.get(field.labelCode).hasError('max') && validation.name.toLocaleLowerCase() =='rangevalidator') {
              <mat-error>{{validation.message}}</mat-error>
            }
            @if (group.get(field.labelCode).hasError(validation.name.toLocaleLowerCase()) && validation.name.toLocaleLowerCase() != 'rangevalidator' && validation.name.toLocaleLowerCase()!==required) {
              <mat-error>{{validation.message}}</mat-error>
            }
            @if (group.get(field.labelCode).hasError(required) && validation.name.toLocaleLowerCase()===required ) {
              <mat-error class="error_font">{{field.labelName}} is mandatory</mat-error>
            }
          </ng-container>
        }
      </mat-form-field>
    }
